export const sectors = [
  "Sivil Toplum (STK, Düşünce Kuruluşları)",
  "Kamu Sektörü",
  "Uluslararası Organizasyon",
  "Özel Sektör",
  "Akademi (Üniversite)",
  "Medya / Gazeteci",
  "Serbest Meslek",
  "Girişimci",
  "Sağlık ve Tıp",
  "Sanat ve Kültür",
  "Hukuk / Avukat",
  "Siyasetçi / Milletvekili"
];

export const sectorsEN = [
  "Academia (University)",
  "Arts and Culture",
  "Civil Society (NGO, Think Tanks)",
  "Entrepreneur",
  "Freelance",
  "Health and Medicine",
  "Law / Lawyer",
  "Media / Journalist",
  "Politician / Member of Parliament",
  "Private Sector",
  "Public Sector",
  "International Organization"
];

export const sectorsForSelect = [
  { "label":"Lütfen seçiniz","value":""},
  { "label":"Sivil Toplum (STK, Düşünce Kuruluşları)","value":"Sivil Toplum (STK, Düşünce Kuruluşları)"},
  { "label":"Kamu Sektörü","value":"Kamu Sektörü"},
  { "label":"Uluslararası Organizasyon","value":"Uluslararası Organizasyon"},
  { "label":"Özel Sektör","value":"Özel Sektör"},
  { "label":"Akademi (Üniversite)","value":"Akademi (Üniversite)"},
  { "label":"Medya / Gazeteci","value":"Medya / Gazeteci"},
  { "label":"Serbest Meslek","value":"Serbest Meslek"},
  { "label":"Girişimci","value":"Girişimci"},
  { "label":"Sağlık ve Tıp","value":"Sağlık ve Tıp"},
  { "label":"Sanat ve Kültür","value":"Sanat ve Kültür"},
  { "label":"Hukuk / Avukat","value":"Hukuk / Avukat"},
  { "label":"Siyasetçi / Milletvekili","value":"Siyasetçi / Milletvekili"}
];

export const sectorsForSelectEN = [
  { "label": "Please select", "value": "" },
  { "label": "Academia (University)", "value": "Academia (University)" },
  { "label": "Arts and Culture", "value": "Arts and Culture" },
  { "label": "Civil Society (NGO, Think Tanks)", "value": "Civil Society (NGO, Think Tanks)" },
  { "label": "Entrepreneur", "value": "Entrepreneur" },
  { "label": "Freelance", "value": "Freelance" },
  { "label": "Health and Medicine", "value": "Health and Medicine" },
  { "label": "Law / Lawyer", "value": "Law / Lawyer" },
  { "label": "Media / Journalist", "value": "Media / Journalist" },
  { "label": "Politician / Member of Parliament", "value": "Politician / Member of Parliament" },
  { "label": "Private Sector", "value": "Private Sector" },
  { "label": "Public Sector", "value": "Public Sector" },
  { "label": "International Organization", "value": "International Organization" }
];

